var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[(_vm.activities.length > 0)?_c('ol',_vm._l((_vm.activities),function(activity){return _c('li',{key:activity.id},[_c('CallInfo',{class:_vm.$style.callInfo,attrs:{"activity":activity,"info":['category', 'stage', 'rating'],"actions":['play']}})],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22f1eaeb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/RecentActivity.vue
// module id = lh05
// module chunks = 1